// Angular
import { Component, OnInit, OnChanges, Input } from '@angular/core';
// Services
import { ApiService } from './../../services/api';
import { ElasticService } from './../../services/elastic';
// External
import * as lodash from 'lodash';
import { environment } from './../../../environments/environment'
import { AngularFireDatabase } from 'angularfire2/database';

@Component({
    selector: 'app-user-select-modal-multi-round',
    templateUrl: './user-select-modal.component.html',
    styleUrls: ['./user-select-modal.component.scss']
})

export class UserSelectModalComponentMultiRound implements OnInit, OnChanges {

    @Input() tournamentId: string;
    public query: string;
    public users: Array<any>;
    public tournament;
    private typingDelay: any;
    public selectedUsers: Array<any>
    public alreadySelected: Array<any>
    public notify;
    public openUserForm = false;
    constructor(private apiService: ApiService, private fireDatabase: AngularFireDatabase, private elasticService: ElasticService) {
        this.query = '';
        this.selectedUsers = []
    }

    ngOnInit() {
        let self = this
        $('#invite-users').on('hidden.bs.modal', function () {
            self.openUserForm = false;
        });
       
        this.query = '';
        this.apiService.object("multi-round/" + this.tournamentId).then((res) => {
            this.tournament = res;
            this.alreadySelected = []

            lodash.forEach(res.enteries, (item, key) => {
                if (item) {
                    this.alreadySelected.push(key)
                }

            })
            this.searchMention();

        })
    }

    displayHandicap(handicap) {
        return parseFloat(handicap).toFixed(1);
    }


    ngOnChanges() {
    }

    searchMention() {
        const queryParams = {
            'index': 'users',
            'type': 'user',
            'body/query/bool/must/query_string/query': `${this.query}*`,
            'body/query/bool/must/query_string/fields': ['fullName^10', 'username^2']
        };

        this.elasticService.search(queryParams)
            .then(result => {
                this.users = [];
                if (result&&result['hits']) {
                    lodash.forEach(result['hits'], item => {
                        const user = lodash.assign({ $key: item['_id'] }, item['_source']);
                        if (this.alreadySelected.findIndex(id => id == user.$key) == -1) {
                            user.isSelected = this.selectedUsers.findIndex(id => id == user.$key) != -1
                            this.users.push(user);

                        }
                    });
                }

            })
            .catch(error => {
                console.error(error);
            });
    }

    changeQuery() {
        clearTimeout(this.typingDelay);

        this.typingDelay = setTimeout(() => {
            this.searchMention();
            console.log("change")
        }, 400);
    }
    selectedUser: any;
    inviteUser(user) {

        this.selectedUser = user;
        this.selectedUser.handicap = parseFloat(this.selectedUser.handicap).toFixed(1);
        this.openUserForm = true;
        if (!user.isSelected) {
            this.selectedUsers.push(user.$key)

            user.isSelected = true

        } else {
            user.isSelected = false

            let i = this.selectedUsers.findIndex(id => id == user.$key)
            this.selectedUsers.splice(i, 1)
        }
    }
    validateHandicapRequired()
    {
        
        let returnVal;


        let globalRegex=new RegExp("^([-]{0,1})([1-9]{1,2}|[1-9]{1,1}[0-9]{1,1})([.]{1}[0-9]{1})?$") ;

        let regExTest = globalRegex.test(this.selectedUser.handicap)
        if (regExTest && !isNaN(parseFloat(this.selectedUser.handicap)) && parseFloat(this.selectedUser.handicap) >= -10.9 && parseFloat(this.selectedUser.handicap) <= 54.9 && this.selectedUser.handicap.length <6)
        {
            returnVal = false;
        }
        else
        {
            returnVal =  true;
        }
        console.log("handicap ", this.selectedUser.handicap, parseFloat(this.selectedUser.handicap), isNaN(parseFloat(this.selectedUser.handicap)), returnVal);
        return returnVal;
        
        // if(this.selectedUser.handicap.length<1 || this.selectedUser.handicap == null || typeof this.selectedUser.handicap === undefined)
        // {
        //     return true;
        // }
        // else{
        //     return false
        // }
    }

    validateOnlyHandicap(event)
    {
    if(
        event.keyCode == 8 || //backspace
        event.keyCode == 37 || //left arrow
        event.keyCode == 39 || //right arrow
        event.keyCode == 46 || //delete
        event.keyCode == 189 || //-
        event.keyCode == 190 || //.
        event.keyCode == 109 || //- numLock
        event.keyCode == 110 || //. numLock
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.keyCode >= 96 && event.keyCode <= 105)
        ) {
        return true;
        }
        return false;
  }
    public submit() {
        console.log(this.tournamentId)
        if (this.selectedUsers && this.selectedUsers.length == 0) {
            alert('Please select atleast one player')
            return
        }
        if (confirm('Are you sure, you want to add this player?')) {
            var update = {}
            console.log(this.selectedUsers)
            for (let k = 0; k < this.selectedUsers.length; k++) {
                const element = this.selectedUsers[k];
                update[`/multi-round/${this.tournamentId}/enteries/${element}`] = true
                update[`/multi-round/${this.tournamentId}/multiround-handicap/${element}`] = parseFloat(this.selectedUser.handicap)
                for (let j = 0; j < this.tournament.tournamentsRound.length; j++)
                {
                    update[`/tournaments/${this.tournament.tournamentsRound[j]}/enteries/${element}`] = true
                    update[`/tournaments/${this.tournament.tournamentsRound[j]}/multiround-handicap/${element}`] = parseFloat(this.selectedUser.handicap);
                    update[`/user-tournaments/${element}/${this.tournament.tournamentsRound[j]}`] = 1
                    update[`/tournament-followings/${this.tournament.tournamentsRound[j]}/followings/${element}`] = null;
                    update[`/user-tournament-scorecard-appversion/${element}/${this.tournament.tournamentsRound[j]}`] = {
                        "userType": "2",
                        "appType": 1,
                        "versionName": environment.version + "",
                        "versionCode": environment.version + "",
                        "platformType": "3",
                        "osVersion": navigator.platform,
                        "brandName": navigator.vendor,
                        "modelName": navigator.userAgent,
                        "imei": "",
                        "createdAt": new Date().getTime() / 1000
                    }
                }
            }
           
            this.apiService.bulkUpdate(update)
                .then(() => {
                    $('#invite-users').modal('hide');
                    // location.reload()
                    this.selectedUsers = []
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
    public close(){
        this.query=""
        this.changeQuery();
    }
}
